module.exports = __webpack_public_path__ + "img/dragon.18a1dbc9.svg";